import { URL } from "../../api/Api";
import { catchError, GET, POST } from "../axios/Axios";

export const JobStatusTracker = async () => {
  try {
    const response = await GET(`${URL}/intake/track/status`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobPauseAutomation = async (payload) => {
  try {
    const response = await POST(
      `${URL}/automation/pause_automation/`,
      payload,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobResumeAutomation = async (payload) => {
  try {
    const response = await POST(
      `${URL}/automation/resume_automation/`,
      payload,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};
